import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { AdminService } from 'src/app/core/services/admin.service';
import { RemovedEndpoint } from 'src/app/core/models/removed-endpoint';

@Component({
  selector: 'app-removed-endpoints',
  templateUrl: './removed-endpoints.component.html',
  standalone: false,
})
export class RemovedEndpointsComponent implements OnInit {
  allEndpoints: RemovedEndpoint[] = [];
  endpoints: RemovedEndpoint[] = [];
  loading = false;
  searchText = '';

  constructor(private adminService: AdminService) {}

  ngOnInit(): void {
    this.loadRemovedEndpoints();
  }

  loadRemovedEndpoints(): void {
    this.loading = true;
    this.adminService
      .getRemovedEndpoints()
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (items: RemovedEndpoint[]) => {
          this.allEndpoints = items || [];
          this.applyFilter();
        },
        error: () => {},
      });
  }

  handleSearch(text: string): void {
    this.searchText = text?.toLowerCase() || '';
    this.applyFilter();
  }

  applyFilter(): void {
    this.endpoints = this.searchText
      ? this.allEndpoints.filter((e) =>
          [e.routePath, e.displayName, e.permissionKey, e.httpMethod]
            .join(' ')
            .toLowerCase()
            .includes(this.searchText),
        )
      : [...this.allEndpoints];
  }

  // Mensagem de contagem regressiva exibida ao usuário (em inglês).
  deletionMessage(endpoint: RemovedEndpoint): string {
    const days = endpoint.daysUntilDeletion;
    if (days <= 0) {
      return 'Will be permanently removed during the next cleanup.';
    }

    const dayLabel = days === 1 ? 'day' : 'days';
    if (endpoint.scheduledDeletionAt) {
      const date = new Date(endpoint.scheduledDeletionAt).toLocaleDateString();
      return `Will be removed in ${days} ${dayLabel} (on ${date}).`;
    }

    return `Will be removed in ${days} ${dayLabel}.`;
  }

  // Define a cor do alerta conforme a proximidade da exclusão.
  deletionSeverityClass(endpoint: RemovedEndpoint): string {
    if (endpoint.daysUntilDeletion <= 7) {
      return 'bg-red-50 text-red-700 border-red-200';
    }
    if (endpoint.daysUntilDeletion <= 15) {
      return 'bg-amber-50 text-amber-700 border-amber-200';
    }
    return 'bg-blue-50 text-blue-700 border-blue-200';
  }

  hasAssociations(endpoint: RemovedEndpoint): boolean {
    return (
      (endpoint.groups?.length || 0) > 0 ||
      (endpoint.users?.length || 0) > 0 ||
      (endpoint.tenants?.length || 0) > 0
    );
  }

  methodClass(method: string): string {
    switch ((method || '').toUpperCase()) {
      case 'GET':
        return 'bg-blue-100 text-blue-700';
      case 'POST':
        return 'bg-green-100 text-green-700';
      case 'PUT':
      case 'PATCH':
        return 'bg-amber-100 text-amber-700';
      case 'DELETE':
        return 'bg-red-100 text-red-700';
      default:
        return 'bg-gray-100 text-gray-600';
    }
  }
}
